<div class="container">
  <div class="row">
    <div class="col-12">
      <h2>{{ 'My children' | translate }}</h2>
      <h3>{{ 'Add and edit your children' | translate }}</h3>
    </div>
  </div>
  <app-children-list [children]="partner.children" (eventListItemClicked)="childListItemClicked($event)"></app-children-list>
  <router-outlet (activate)="onActivate($event)"></router-outlet>
</div>
